<dialog #dialogElement class="modal modal-bottom sm:modal-middle">
  <div class="modal-box">
    <p class="text-xl font-bold">{{ label() }}</p>
    @if (description()) {
      <p class="py-2">{{ description() }}</p>
    }
    <div class="modal-action">
      <form method="dialog">
        <div class="flex flex-row gap-2">
          <app-button
            [id]="'confirm-modal-button'"
            [color]="'primary'"
            (clicked)="confirm()"
            label="Confirm"
            type="button" />
          <app-button
            [id]="'cancel-modal-button'"
            (clicked)="close()"
            label="Cancel"
            type="button" />
        </div>
      </form>
    </div>
  </div>
</dialog>
